import React from 'react';
import { FormComponentProps } from 'antd/lib/form';
import { Form, Modal, Button, Input ,message} from 'antd';
import { invoiceInput } from 'src/api';
const FormItem = Form.Item;
interface UserFormProps extends FormComponentProps {
    onCloseModal: () => void;
    onFresh:()=>void;
}
class Component extends React.Component<any, any> {
    onCloseModal = () => {
        this.props.onCloseModal();
    }
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if(!err){
                invoiceInput.CreatGroup(this, values).then((response: any) => {
                    const err2 = response.er;
                    const res = response.res;
                    if (err2) {
                        message.error(err2.status.description);
                        return null;
                    } else {
                        if(res){
                            message.success(res.description);
                            this.props.onFresh();
                            this.onCloseModal();
                        }
                    }
                });
            }
        });
    }
    render() {
        
        return (
            <Modal
                visible={true}
                onCancel={this.props.onCloseModal}
                footer={null}
                title="新增发票组"
            >
                <Form onSubmit={this.handleSubmit}>
                    <p>确认新增吗？</p>
                    <div style={{ 'textAlign': 'center' }}>
                        <Button type="primary" htmlType="submit">确认</Button>
                    </div>
                </Form>

            </Modal>
        );
    }

}
const WrappedModalForm = Form.create()(Component);
export default WrappedModalForm as any;



// WEBPACK FOOTER //
// ./src/display/apps/InvoiceInput/UI.CreatGroup.tsx